import {
  Grid,
  Card,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Divider,
  CardHeader,
  Typography,
} from '@mui/material';
import { useDashboardSMSQuery } from '../../Components/Dashboard/api/dashboardEndPoint';
import TableLoader from '../../Components/Spinner/TableLoader';
import SMSTableRow from './SMSTableRow';

const SMSTable = () => {
  const { allNotice, isLoading } = useDashboardSMSQuery();
  return (
    <Box mt={5}>
      <Grid container>
        <Grid item xs={12}>
          <Card>
            <CardHeader
              title={
                <Typography
                  sx={{ fontWeight: 700, lineHeight: 1.34, fontSize: 17 }}
                >
                  SMS List
                </Typography>
              }
            />
            <Divider />
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>SL</TableCell>
                  <TableCell>Text</TableCell>
                  <TableCell>Create date</TableCell>
                  {/* <TableCell>Action</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableLoader />
                ) : allNotice.length ? (
                  <>
                    {allNotice?.map((sNotice, index) => {
                      return (
                        <SMSTableRow
                          index={index}
                          sNotice={sNotice}
                          key={sNotice.id}
                        />
                      );
                    })}
                  </>
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SMSTable;
